import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from 'common/ui/button';
import { Input } from 'common/ui/input';
import { Label } from 'common/ui/label';
import { Controller, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { sanitizeFormData } from 'utils/filter-form';
import { z } from 'zod';

const filterSchema = z.object({
  search: z.string().optional(),
});

type FilterFormValues = {
  search?: string,
};

export const FilterForm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, ...queryParams } = Object.fromEntries(searchParams.entries());

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(filterSchema),
    defaultValues: {
      search: search || '',
    },
  });

  const onSubmit = (data: FilterFormValues) => {
    const sanitizedData = sanitizeFormData(data);
    setSearchParams({
      ...queryParams,
      ...sanitizedData,
    });
  };

  const handleReset = () => {
    reset({
      search: '',
    });
    setSearchParams(queryParams);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-wrap gap-2">
        <div className="flex flex-col gap-1 min-w-[200px]">
          <Label htmlFor="search">Search</Label>
          <Controller
            name="search"
            control={control}
            render={({ field }) => (
              <Input
                type="text"
                id="search"
                placeholder="Search..."
                value={field.value || ''}
                onChange={e => field.onChange(e.target.value)}
              />
            )}
          />
          {errors.search && (
            <p className="text-red-500 text-sm">{errors.search.message}</p>
          )}
        </div>

        <div className="flex gap-1 self-end">
          <Button type="submit">Filter</Button>
          <Button type="button" variant="outline" onClick={handleReset}>
            Reset
          </Button>
        </div>
      </div>
    </form>
  );
};
